import {
    NEW_OUTRAS_SAIDA_ANIMAL_SUCCESS,
    TABLE_OUTRAS_SAIDA_ANIMAL_PENDING,
    TABLE_OUTRAS_SAIDA_ANIMAL_SUCCESS,
    TABLE_OUTRAS_SAIDA_ANIMAL_FAILURE,
    LIST_OUTRAS_SAIDA_ANIMAL_PENDING,
    LIST_OUTRAS_SAIDA_ANIMAL_SUCCESS,
    LIST_OUTRAS_SAIDA_ANIMAL_FAILURE,
    FIND_OUTRAS_SAIDA_ANIMAL_PENDING,
    FIND_OUTRAS_SAIDA_ANIMAL_SUCCESS,
    FIND_OUTRAS_SAIDA_ANIMAL_FAILURE,
    DELETE_OUTRAS_SAIDA_ANIMAL_PENDING,
    DELETE_OUTRAS_SAIDA_ANIMAL_SUCCESS,
    DELETE_OUTRAS_SAIDA_ANIMAL_FAILURE,
    CREATE_OUTRAS_SAIDA_ANIMAL_PENDING,
    CREATE_OUTRAS_SAIDA_ANIMAL_SUCCESS,
    CREATE_OUTRAS_SAIDA_ANIMAL_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function outrasSaidaAnimalReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_OUTRAS_SAIDA_ANIMAL_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_OUTRAS_SAIDA_ANIMAL_PENDING:
        case FIND_OUTRAS_SAIDA_ANIMAL_PENDING:
        case DELETE_OUTRAS_SAIDA_ANIMAL_PENDING:
        case CREATE_OUTRAS_SAIDA_ANIMAL_PENDING:
        case TABLE_OUTRAS_SAIDA_ANIMAL_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_OUTRAS_SAIDA_ANIMAL_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_OUTRAS_SAIDA_ANIMAL_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_OUTRAS_SAIDA_ANIMAL_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_OUTRAS_SAIDA_ANIMAL_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_OUTRAS_SAIDA_ANIMAL_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_OUTRAS_SAIDA_ANIMAL_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_OUTRAS_SAIDA_ANIMAL_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_OUTRAS_SAIDA_ANIMAL_SUCCESS:
        case CREATE_OUTRAS_SAIDA_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_OUTRAS_SAIDA_ANIMAL_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { outrasSaidaAnimalReducer };